import { algorithmProblems, findProblemById, type Problem } from '../data/problems';

// Lives apart from codeRunner.ts because it's the only runner-side function
// that needs the problem bank at runtime. Keeping it here lets codeRunner stay
// bank-free so the JS worker chunk doesn't bundle all 1.5 MB of problems.

/** Resolves a route param (e.g. "algo-4", "arr-1", "class-2") to a Problem. Falls back to algo-1. */
export function resolveProblem(problemId: string | undefined): Problem {
  if (!problemId) return algorithmProblems[0];
  return findProblemById(problemId) ?? algorithmProblems[0];
}
